export default __webpack_public_path__ + "static/media/Landing_Orange_Arch_Mobile.4247da30.png";